import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/swipe-down.svg")